import React from 'react';

import SubmitButton from '../Forms/SubmitButton/index.jsx';
import CMSContent from '../CMSContent/index.jsx';

import RestClient from '@scripts/utilities/rest-client.js';


class LogOutEverywhere extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({ loading: true });

    this.props.onClick();
  }

  render() {
    return (
      <React.Fragment>
        <h3>Log Out Everywhere</h3>
        <p dangerouslySetInnerHTML={{ __html: 'This logs you out of the Collective Shift platform everywhere you&#8217;re logged in, including desktop, tablet and mobile devices.' }} />
        <div className="cs-block-button">
          <SubmitButton type="button" onSubmit={this.onClick} loading={this.state.loading}>
            Sign Out
          </SubmitButton>
        </div>
      </React.Fragment>
    );
  }
}


export default LogOutEverywhere;

